import axios from "axios";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const wsUrl = () =>
  `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws?token=${localStorage.getItem("cs_token") || ""}`;

export const formatRp = (n) => `Rp${Math.round(n || 0).toLocaleString("id-ID")}`;

export const formatTokens = (n) => {
  const v = n || 0;
  if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(1).replace(".0", "")} Jt`;
  if (Math.abs(v) >= 1_000) return `${(v / 1_000).toFixed(1).replace(".0", "")} Rb`;
  return `${v}`;
};

export const timeWIB = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("id-ID", {
      hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta",
    }).replace(".", ":");
  } catch {
    return "";
  }
};

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Terjadi kesalahan";
};

export default api;
